import style from "./styles.module.scss"

import { Headline4, Img } from "ui-kit/components-branded"

export function NoDialog() {
    return (
        <div className={style.container}>
            <Img
                className={style.illustration}
                src="success-auth-illustration.svg"
                width={512}
                height={288}
            />
            <Headline4 className={style.text}>Выберите чат</Headline4>
        </div>
    )
}
